export const SendPOSTUserAPI = async (url, headers, params = null) => {
  return await fetch(
    process.env.VUE_APP_USER_API_URL + url,
    {
      method: "POST",
      headers: {
        ...headers,
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Client-Name": process.env.VUE_APP_USER_API_CLIENT_NAME,
      },
      body: JSON.stringify(params)
    }
  ).then(r => r.json());
}

export const SendGETUserAPI = async (url, headers) => {
  return await fetch(
    process.env.VUE_APP_USER_API_URL + url,
    {
      method: "GET",
      headers: {
        ...headers,
        Catch: "no-cache",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Client-Name": process.env.VUE_APP_USER_API_CLIENT_NAME,
      },
    }
  ).then(r => r.json());
}


export const SendPOSTServerAPI = async (url, headers, params = null) => {
  return await fetch(
    process.env.VUE_APP_SERVER_URL + url,
    {
      method: "POST",
      headers: {
        ...headers,
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Client-Name": process.env.VUE_APP_USER_API_CLIENT_NAME,
      },
      body: params
    }
  );
}


export const SendGETServerAPI = async (url, headers) => {
  return await fetch(
    process.env.VUE_APP_SERVER_URL + url,
    {
      method: "GET",
      headers: {
        ...headers,
        Catch: "no-cache",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Client-Name": process.env.VUE_APP_USER_API_CLIENT_NAME,
      },
    }
  ).then(r => r.json());
}
